import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

const KPICard = ({ 
  title, 
  value, 
  icon: Icon, 
  color = 'blue', 
  trend = null, 
  trendValue = null,
  subtitle = null,
  className = ''
}) => {
  const getColorClasses = (color) => {
    const colors = {
      blue: 'bg-[color:var(--surface-muted)] text-[color:var(--accent)] border-[color:var(--border)]',
      green: 'bg-[color:var(--surface-muted)] text-[color:var(--status-good)] border-[color:var(--border)]',
      yellow: 'bg-[color:var(--surface-muted)] text-[color:var(--status-warn)] border-[color:var(--border)]',
      red: 'bg-[color:var(--surface-muted)] text-[color:var(--status-bad)] border-[color:var(--border)]',
      purple: 'bg-[color:var(--surface-muted)] text-[color:var(--accent)] border-[color:var(--border)]',
      indigo: 'bg-[color:var(--surface-muted)] text-[color:var(--accent)] border-[color:var(--border)]'
    };
    return colors[color] || colors.blue;
  };

  const getTrendIcon = (trend) => {
    if (trend === 'up') return <TrendingUp className="w-4 h-4" />;
    if (trend === 'down') return <TrendingDown className="w-4 h-4" />;
    return <Minus className="w-4 h-4" />;
  };

  const getTrendColor = (trend) => {
    if (trend === 'up') return 'text-[color:var(--status-good)]';
    if (trend === 'down') return 'text-[color:var(--status-bad)]';
    return 'text-[color:var(--text-muted)]';
  };

  return (
    <div className={`bg-[color:var(--surface)] rounded-lg shadow-sm border border-[color:var(--border)] p-6 ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-[color:var(--text-muted)] mb-1">{title}</p>
          <div className="flex items-baseline">
            <p className="text-2xl font-bold text-[color:var(--text-primary)]">{value}</p>
            {trend && trendValue && (
              <div className={`ml-2 flex items-center ${getTrendColor(trend)}`}>
                {getTrendIcon(trend)}
                <span className="ml-1 text-sm font-medium">{trendValue}</span>
              </div>
            )}
          </div>
          {subtitle && (
            <p className="text-sm text-[color:var(--text-muted)] mt-1">{subtitle}</p>
          )}
        </div>
        {Icon && (
          <div className={`p-3 rounded-lg border ${getColorClasses(color)}`}>
            <Icon className="w-6 h-6" />
          </div>
        )}
      </div>
    </div>
  );
};

export default KPICard;

